import React from 'react';
import { Button } from '../../genericComponents'
import styled from 'styled-components';

import MembershipComponent from './MembershipComponent'


const Container = styled.div`
  width: 100%;
  padding-right:20px;
  color: ${props => props.theme.color.darkBlue};
`;
const ContentContainer = styled.div`
  padding:0 50px 30px;
  border-radius: 15px;
  background-color: ${props => props.theme.color.softYellow};
  display:flex;
  flex-direction:column;
  justify-content: space-between; 
`;
const Title = styled.div`
  margin-bottom: 10px;
  padding: 10px;
  font-weight: bold;
  font-size: 150%;
`;


const SelectButton = styled(Button)`
  margin:20px auto;
  display:block;
  width: 260px;
  height: 48px;
  border-radius: 5px;
  font-size:16px;
  background: ${props => props.theme.color.gabaYellow};
  color: ${props => props.theme.color.darkBlue};
`
export default function SubscriptionComponent({ membership }) {

  return (
    <Container>
      <Title>Summary</Title>
      <ContentContainer>
        <MembershipComponent
          membership={membership}
          features={membership.membership_features} />
      </ContentContainer>
    </Container >
  );
}
